module.exports = __webpack_public_path__ + "img/l1.56377dfb.jpg";